import React, { useState, useEffect } from 'react'
import './TravelFinished.min.css'
import {AiFillEdit } from 'react-icons/ai'
import axios from 'axios';
import { ipAddress } from '../../ipAddress';
interface Cost {
  id: number;
  name: string;
  isDone: number;
  kwota: number;
}
interface Props {
  cost: Cost;


}

const CostsTravelEnd: React.FC<Props> = ({ cost}) => {
  const [edit, setEdit] = useState<boolean>(false);
  const [editThing, setEditThing] = useState<string>(cost.name);
  const [editCost, setEditCost] = useState<number>(cost.kwota);


  const resize = () => {
    let element = document.getElementById("textAreaEditCost")
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }
  
  const handleEdit = (e: React.FormEvent, id: number) => {

    e.preventDefault();
    axios.post(ipAddress + "/editCostTravelFinished", {
      nameCost: editThing,
      cost: editCost,
      id: id,

    })
      .then((response) => {

      })
      .catch(function (error) {
        console.log("error!")

      })

    setEdit(false)
  }

  const close = () => {
    setEdit(false);
    setEditThing(cost.name);
    setEditCost(cost.kwota);
    
    
    
  }

  return (
    <div className='list'>
      <div className='done'>

        {cost.isDone == 1 ? (

          <span>
            <input type='checkbox' checked={true}
              readOnly
            ></input>
            <s className='text'> {cost.name} {cost.kwota} zł</s>
            <span className='edit' onClick={() => setEdit(true)} ><AiFillEdit /></span>

          </span>


        ) : (
          <span>
            <input type='checkbox' checked={false}
              readOnly
            ></input>
            <span className='edit' onClick={() => setEdit(true)} ><AiFillEdit /></span>
            <span className='text'> {cost.name} {cost.kwota} zł</span>
            
          </span>
        )
        }

        

      </div>

      {edit ? (
        <form className='editThing' onSubmit={(e) => { handleEdit(e, cost.id) }}>

          <button type='button' id='close' onClick={() => close()} >X</button>
          <p>Edytuj koszt wyjazdu</p>
          <div className='thing'>

            <textarea id='textAreaEditCost'
              rows={4}
              value={editThing}
              onChange={(e) => (resize(), setEditThing(e.target.value))}
              onClick={() => resize()}
            ></textarea>
          </div>
          <div className='edit'>
            <label htmlFor="edit">Kwota: </label>
            <input type='number'
              value={editCost}
              onChange={(e) => setEditCost(e.target.valueAsNumber)}
            ></input>
            <span> zł</span>
          </div>
          <button type='submit' id='submit'>OK</button>
        </form>
      ) : (
        <span></span>
      )
      }
     

    </div>


  )
}

export default CostsTravelEnd;